function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button } from '../Button/';

import { injectIntl, defineMessages } from 'react-intl';

var messages = defineMessages({
    error: {
        id: 'editor.status.error',
        defaultMessage: 'Error'
    },
    general: {
        id: 'editor.status.general',
        defaultMessage: 'General'
    },
    private: {
        id: 'editor.status.private',
        defaultMessage: 'Private'
    },
    new: {
        id: 'editor.status.new',
        defaultMessage: 'New'
    },
    draft: {
        id: 'editor.status.draft',
        defaultMessage: 'Draft'
    },
    publish: {
        id: 'editor.status.publish',
        defaultMessage: 'Published'
    },
    trash: {
        id: 'editor.status.trash',
        defaultMessage: 'Trash'
    }
});

var ButtonStatusIntl = function (_Component) {
    _inherits(ButtonStatusIntl, _Component);

    function ButtonStatusIntl() {
        _classCallCheck(this, ButtonStatusIntl);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ButtonStatusIntl.prototype.render = function render() {
        var _props = this.props,
            status = _props.status,
            link = _props.link;


        if (!status) {
            return false;
        }

        var label = status;

        if (messages[status]) {
            label = this.props.intl.formatMessage(messages[status]);
        }

        return React.createElement(Button, { className: 'admin-button  admin-button--status', link: link, icon: 'remove_red_eye', label: label });
    };

    return ButtonStatusIntl;
}(Component);

export default injectIntl(ButtonStatusIntl);